import { render } from "./collapse.vue?vue&type=template&id=6501848b&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=6501848b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6501848b"

export default script